import React, {Component} from 'react'
import {Redirect, Route, RouteComponentProps, Switch, withRouter} from 'react-router'
import {withTranslation, WithTranslation} from 'react-i18next'
import HomePage from './pages/home'
import MyTimeSheet from './pages/timesheet/my-timesheet'
import MyTeamTimeSheet from './pages/timesheet/teams-timesheet'
import MyTeamReport from './pages/timesheet/my-timesheet-reports'
import CompanyListPage from './pages/admin/companies/company-list'
import AdminPage from './pages/admin/admin'
import UserGuideEditor from './pages/admin/user-guide/user-guide-editor'
import CompanyDetailPage from './pages/admin/companies/company-detail'
import CompanyUserPage from './pages/admin/companies-users/company-user-list'
import EmployeeDetailPage from './pages/admin/companies/employees/employee-detail'
import ProjectDetailPage from './pages/admin/projects/project-detail'
import ProjectEmployeePage from './pages/admin/projects/projects-assignments/project-employee'
import ProjectTaskPage from './pages/admin/projects/projects-assignments/project-task'
import TimesheetDetailPage from './pages/admin/timesheets/timesheet-detail'
import WhatsNewReportUserView from './pages/admin/app-settings/whats-new/whats-new-report-user'
import Shell from 'src/core/ui/shell'
import {getSideMenu, getTopMainMenu, getTopRightMenu} from './menu'
import {IdentityProps, withIdentity} from './core/services/authentication'
import error404 from './core/ui/error/error404'
import moment from 'moment-timezone'
import RestrictionPlanDetail from './pages/admin/restriction-plan/restriction-plan-detail'
import {ClickParam} from 'antd/lib/menu'
import {Button, Modal} from 'antd'
import autobind from 'autobind-decorator'
import AppSettings from 'src/pages/admin/app-settings/app-settings'
import {withAITracking} from '@microsoft/applicationinsights-react-js'
import {aiPlugin} from 'src/telemetry'
import {NotificationProps, withNotification} from './consumer/notificationContent'
import NotificationView from 'src/pages/user/notification'
import ShellIdleApp from 'src/core/ui/shell-idle-app'
import i18next from './i18n'
import HttpService from 'src/core/services/http.service'
import {resolve} from 'src/inversify.config'
import {UserProfileProps, withUserProfile} from './components/user-profile'
import myTimesheetReports from './pages/timesheet/my-timesheet-reports'


moment.tz.setDefault("etc/UTC") //set Default Timezone for moments
const logo = require('src/core/assets/logo.png')
const footerLogo = require('src/core/assets/footer-logo.png')
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')
interface AppProps extends RouteComponentProps, WithTranslation, NotificationProps, IdentityProps, UserProfileProps {
}

interface AppState {
  collapsed: boolean
  showManagerContent: boolean
  showNotificationModal: number
  roles: string[]
}

class App extends Component<AppProps, AppState> {
  @resolve(HttpService)
  private httpService!: HttpService
  constructor(props: AppProps & IdentityProps) {
    super(props)
    this.state = {
      collapsed: false,
      showManagerContent: false,
      showNotificationModal: 0,
      roles: []

    }
  }

  @autobind
  public onMenuClick(item: ClickParam) {
    switch (item.key) {
      case 'whatsnew':
        if (this.props.location.pathname.match("admin")) {
          this.setState({ collapsed: true, showManagerContent: true })
        }
        else {
          this.setState({ collapsed: true, showManagerContent: false })
        }
        break
      case 'notification':

        this.setState({ showNotificationModal: this.state.showNotificationModal + 1 })

        break
      case 'hangfire':

        window.open(baseUrl + "hangfire?access_token=" + HttpService.accessToken,  "blank")

        break
    }
  }

  render() {

    return <ShellIdleApp timeout={1000 * 60 * 30} >
      <Shell v2 logo={logo} footerLogo={footerLogo} getSideMenu={getSideMenu} getTopMainMenu={getTopMainMenu} getTopRightMenu={getTopRightMenu(this.props.userProfile.roles || [], this.onMenuClick, i18next.language)} onMenuClick={this.onMenuClick}>
        <Switch>

          <Route exact path='/' component={() => <Redirect to="/time-tracking/my-timesheet" />} />
          <Route exact path='/time-tracking' component={() => <Redirect to="/time-tracking/my-timesheet" />} />
          <Route exact path='/time-tracking/my-timesheet' component={MyTimeSheet} />
          <Route exact path='/time-tracking/my-team-timesheet' component={MyTeamTimeSheet} />
          <Route exact path='/time-tracking/my-timesheet-report' component={myTimesheetReports} />
          <Route exact path='/time-tracking/guide' component={UserGuideEditor} />
          <Route exact path='/time-tracking/admin' component={AdminPage} />
          <Route exact path='/time-tracking/admin/manual' component={UserGuideEditor} />
          <Route exact path='/time-tracking/admin/companies' component={CompanyListPage} />
          <Route exact path='/time-tracking/admin/companies/:companyId' component={CompanyDetailPage} />
          <Route exact path='/time-tracking/admin/companies-users' component={CompanyUserPage} />
          <Route exact path='/time-tracking/admin/companies/:companyId/projects/projects-assignments' component={ProjectEmployeePage}  />
          <Route exact path='/time-tracking/admin/companies/:companyId/projects/templates-assignments' component={ProjectTaskPage}  />

          <Route exact path='/time-tracking/admin/companies/:companyId/projects'
            render={(props) => {
              return <Redirect to={{
                pathname: `/time-tracking/admin/companies/${(props.match.params as any).companyId}`,
                search: "?tab=projects"
              }} />
            }} />
          <Route exact path='/time-tracking/admin/companies/:companyId/employees/:employeeId/timesheets'
            render={(props) => {
              return <Redirect to={{
                pathname: `/time-tracking/admin/companies/${(props.match.params as any).companyId}`,
                search: "?tab=timesheets"
              }} />
            }} />
          <Route exact path='/time-tracking/admin/companies/:companyId/employees'
            render={(props) => {
              return <Redirect to={{
                pathname: `/time-tracking/admin/companies/${(props.match.params as any).companyId}`,
                search: "?tab=employees"
              }} />
            }} />
          <Route exact path='/time-tracking/admin/companies/:companyId/restrictionplans'
            render={(props) => {
              return <Redirect to={{
                pathname: `/time-tracking/admin/companies/${(props.match.params as any).companyId}`,
                search: "?tab=restrictionplans"
              }} />
            }} />
          <Route exact path='/time-tracking/admin/companies/:companyId/templates'
            render={(props) => {
              return <Redirect to={{
                pathname: `/time-tracking/admin/companies/${(props.match.params as any).companyId}`,
                search: "?tab=templates"
              }} />
            }} />

          <Route exact path='/time-tracking/admin/companies/:companyId/employees/:employeeId' component={EmployeeDetailPage} />
          <Route exact path='/time-tracking/admin/companies/:companyId/employees/:employeeId/timesheets' component={CompanyDetailPage} />
          <Route exact path='/time-tracking/admin/companies/:companyId/employees/:employeeId/timesheets/:timesheetId' component={TimesheetDetailPage} />
          <Route exact path='/time-tracking/admin/companies/:companyId/projects/:projectId' component={ProjectDetailPage} />
          <Route exact path='/time-tracking/admin/companies/:companyId/projects/:projectId/:employeeId' component={EmployeeDetailPage} />
          <Route exact path='/time-tracking/admin/companies/:companyId/restrictionplans/:restrictionPlanId' component={RestrictionPlanDetail} />
          <Route exact path='/time-tracking/admin/appsettings' component={AppSettings} />
          <Route component={error404} />
        </Switch>

        <NotificationView
          identity={this.props.identity} forceShowModal={this.state.showNotificationModal}
        />

        <Modal
          title={this.props.t("What's New")}
          visible={this.state.collapsed}
          style={{ top: 20 }}
          width="80%"
          closable={false}
          onCancel={() => this.setState({ collapsed: false })}
          onOk={() => this.setState({ collapsed: false })}
          footer={[
            <Button key="back" type="primary" onClick={() => this.setState({ collapsed: false })}>
              {this.props.t('Ok')}
            </Button>
          ]}>
          <WhatsNewReportUserView showManagerContent={this.state.showManagerContent} reload={this.state.collapsed} />
        </Modal>
      </Shell>
    </ShellIdleApp>
  }
}

export default withUserProfile( withIdentity(withNotification(withRouter(withTranslation()(withAITracking(aiPlugin, App)) as any) as any) as any) as any)